import { extractFirstLetterFromKey } from './extractFirstLetterFromKey'
import type { Case } from 'types/case'
import { formatCaseDetailValue } from './formatCaseDetailValue'
import { determineCaseDetailType } from './determineCaseDetailType'

type ResolveCaseDetailValueProps = {
  path: string
  initialText: string
  value: string
  caseDetails: Case
}

export const resolveCaseDetailValue = ({
  path,
  initialText,
  value,
  caseDetails,
}: ResolveCaseDetailValueProps) => {
  // First letter logic
  const firstLetterResult = extractFirstLetterFromKey(
    path,
    initialText,
    caseDetails,
  )
  if (firstLetterResult) return firstLetterResult

  // otherwise, continue resolving with the original params --> path, value, and initialText
  const formattedValue = formatCaseDetailValue({ value, path })

  const type = determineCaseDetailType({
    value: formattedValue,
    initialText,
    path,
  })

  return { path, value: formattedValue, initialText, type }
}
